'use strict';
// 返回采编图片读取地址的格式
angular.module('trsDocTypeModule', []).filter('trsDocType', [
    function() {
        return function(input) {
            if (angular.isDefined(input)) {
                if (input) {
                    let doctypeNameMap = {
                        1: '新闻',
                        2: '图集',
                        3: '专题',
                        4: '链接',
                        5: '活动',
                        6: '话题', 
                        7: '视频',
                        8: '直播',
                        12: '音频',
                        13: '视频专辑',
                        14: '运营活动',
                        15: '广告',
                    };
                    input = doctypeNameMap[parseInt(input)];
                }
                return input;
            }
        };
    },
]);
